import breakpoints from '../data/breakpoints';
import Slider from '../components/slider';
import $ from 'jquery';
import 'jquery.animate-number';
import 'jquery-inview';


class Performance {
    constructor(el) {
        this.el = el;
        this.sliderEl = el.find('.slider');
        this.hasContent = el.find('.performance__content').length > 0;
        this.statNumberEl = this.el.find('.performance__stat__value');
        this.slider = new Slider(this.sliderEl, {
            responsive: [
                {
                    breakpoint: breakpoints.tablet - 1,
                    settings: {
                        slidesToShow: this.hasContent ? 1 : 2
                    }
                },
                {
                    breakpoint: breakpoints.desktop - 1,
                    settings: 'unslick'
                }
            ]
        });

        this.statNumberEl.one('inview', function () {
            const $el = $(this);
            let value = $el.text().trim();

            if ($el.data('disableCounting')) {
                return;
            }
            if (!value.match(/(.*)\d(.*)/)) {
                return;
            }
            const prefix = (value.match(/^(\D*)/) || '')[0] || '';
            const suffix = (value.match(/\D$/) || '')[0] || '';
            value = value.replace(/\D+/g, '') || '';
            if (!value) {
                return;
            }
            $el.animateNumber({
                number: value,
                easing: 'easeInQuad',
                numberStep: function (now, tween) {
                    const flooredNumber = Number(Math.floor(now)).toLocaleString();
                    $(tween.elem).text(`${prefix}${flooredNumber}${suffix}`);
                }
            }, 1800);
        });

        /**
         * Events
         */

    }
}

export default Performance;